
import { GET_ALL_SERVICE_PRODUCT, GET_ALL_SERVICE_PRODUCT_FAILED, GET_ALL_SERVICE_PRODUCT_SUCCESS, GET_BILLING_INFO, GET_BILLING_INFO_FAILED, GET_BILLING_INFO_SUCCESS, GET_SERVICE_DATA, GET_SERVICE_DATA_FAILED, GET_SERVICE_DATA_SUCCESS } from "../../constants/storeConstant";

const initialState = {
    products: [],
    services: [],
    billings: [],
    isLoading: false,
    error: null
}

const StoreDataReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_ALL_SERVICE_PRODUCT:
            return {
                ...state,
                isLoading: true,
            }
        case GET_ALL_SERVICE_PRODUCT_SUCCESS:
            return {
                ...state,
                products: action.payload || [],
                isLoading: false,
                error: null
            }
        case GET_ALL_SERVICE_PRODUCT_FAILED:
            return {
                isLoading: false,
                error: action.payload
            }


        case GET_BILLING_INFO:
            return {
                ...state,
                isLoading: true,
            }
        case GET_BILLING_INFO_SUCCESS:
            return {
                ...state,
                billings: action.payload || [],
                isLoading: false,
                error: null
            }
        case GET_BILLING_INFO_FAILED:
            return {
                isLoading: false,
                error: action.payload
            }


        case GET_SERVICE_DATA:
            return {
                ...state,
                isLoading: true,
            }
        case GET_SERVICE_DATA_SUCCESS:
            return {
                ...state,
                services: action.payload || [],
                isLoading: false,
                error: null
            }
        case GET_SERVICE_DATA_FAILED:
            return {
                isLoading: false,
                error: action.payload
            }
            
            
        default:
            return state;
    }
}

export default StoreDataReducer;